export default {
  title: '素材ライブラリ',
  tabImage: '画像',
  tabVideo: '動画',
  allGroups: 'すべてのグループ',
  addGroup: 'グループ追加',
  editGroup: 'グループ編集',
  deleteGroup: 'グループ削除',
  groupName: 'グループ名',
  groupNamePlaceholder: 'グループ名を入力してください',
  confirmDeleteGroup:
    'このグループを削除してもよろしいですか？削除後、グループ内の素材は未分類に移動します。',
  upload: '画像アップロード',
  uploadVideo: '動画アップロード',
  batchGroup: '一括グループ',
  batchDelete: '一括削除',
  searchName: '画像名',
  searchNamePlaceholder: '名前を入力してください',
  selected: '選択済み',
  item: '件',
  cancelSelect: '選択解除',
  preview: 'プレビュー',
  copyLink: 'リンクコピー',
  confirmDelete: '選択した素材を削除してもよろしいですか？',
  confirmDeleteSingle: 'この素材を削除してもよろしいですか？',
  copySuccess: 'リンクをコピーしました',
  moveSuccess: '移動しました',
  uploadSuccess: 'アップロードしました',
  uploadTitle: '素材アップロード',
  dragTip: 'クリックまたはファイルをドラッグしてアップロード',
  uploadLimit: 'JPG、PNG、GIF形式に対応、1枚あたり5MB以下',
  uploadVideoLimit: 'MP4、AVI形式に対応、1個あたり500MB以下',
  editTitle: '素材編集',
  materialName: '素材名',
  materialNamePlaceholder: '素材名を入力してください',
  moveGroupTitle: 'グループへ移動',
  targetGroup: '対象グループ',
  selectGroupPlaceholder: 'グループを選択してください',
  ungrouped: '未分類',
  emptyImage: '画像がありません',
  emptyVideo: '動画がありません',
  uploadNow: '今すぐアップロード',
  videoCover: '動画カバー',
  uploadCover: 'カバーアップロード',
  uploadFile: 'ファイルアップロード',
  uploadFileRequired: 'アップロードするファイルを選択してください',
  videoCoverRequired: '動画カバーをアップロードしてください',
  fileSizeExceed: 'ファイルサイズが{max}を超えています',
};
